import React from "react";

import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	Flex,
} from "@chakra-ui/react";
import {
	IconTrashCanLight as RemoveIcon,
	Text5,
	ButtonPrimary,
	ButtonSecondary,
} from "@telefonica/mistica";
import { strings } from "../../../../localization";

interface RemoveSellersCodeModalProps {
	isOpen: boolean;
	onClose(): void;
	onConfirm(): void;
}

const RemoveSellersCodeModal: React.FC<RemoveSellersCodeModalProps> = ({ isOpen, onClose, onConfirm }) => {
	const texts = strings.components.withdrawResume.sellersCode.modal;

	return (
		<Modal
			isOpen={isOpen} onClose={onClose} isCentered
			size="md"
		>
			<ModalOverlay />
			<ModalContent
				sx={{
					background: "#ffff",
				}}
				maxW="431px"
				padding="32px 24px"
			>
				<ModalHeader p={0} marginBottom="24px">
					<RemoveIcon size={64} color="#660099" />
				</ModalHeader>
				<ModalCloseButton color="#00000" />
				<ModalBody px={0}>
					<Flex mb={"40px"}>
						<Text5>
							{texts.remove_title}
						</Text5>
					</Flex>
				</ModalBody>
				<ModalFooter justifyContent="flex-start" px={0} py={0}>
					<Flex gap={4}>
						<ButtonSecondary
							style={{
								minWidth: "180px",
							}}
							onPress={onClose}
						>
							{texts.btn_cancel}
						</ButtonSecondary>
						<ButtonPrimary
							style={{
								minWidth: "180px",
							}}
							onPress={() => onConfirm()}
						>
							{texts.btn_remove}
						</ButtonPrimary>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default RemoveSellersCodeModal;
